<template>
    <div>
        <Navigation :transparent="false" :alwaysTop="true" />
        <div class="fullsize-content">
            <div class="home-page">
                <section class="home-page__body">
                    <div class="home-page__body-content">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="error-template">
                                        <p class="error-line-a-heading">
                                            {{$t("errorLayout.subheading_a")}}
                                        </p>

                                        <h1 class="error-code-heading">
                                            404 <br>
                                            {{$t("errorLayout.heading_404")}}
                                        </h1>

                                        <div class="error-details mt-4">
                                            <p>
                                                {{$t("errorLayout.error_message_404")}}
                                            </p>
                                        </div>

                                        <div class="error-actions button-group button-group--responsive responsive--center-s">
                                            <router-link
                                                v-if="$route.path !== '/'"
                                                :to="localeRoute('home')"
                                                class="button success--button button--l">
                                                {{$t("errorLayout.home_button")}}
                                            </router-link>
                                            <a :href="homePath"
                                                v-else
                                                class="button success--button button--l">
                                                {{$t("errorLayout.home_button")}}
                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <app-footer v-if="footerContent"/>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from '../components/ui/Navigation/Navigation';

export default {
    props: ['error'],
    components: {
        Navigation
    },
    computed: {
        homePath() {
            return this.$router.resolve(this.localeRoute({name: 'home'})).href;
        }
    }
}
</script>

<style scoped>
.error-template {
    padding: 40px 15px;
    text-align: center;
}

.error-actions {
    margin-top:15px;
    margin-bottom:15px;
}

.error-footer {
    position: relative;
}

.error-code-heading {
    font-size: 50px;
}

.error-line-a-heading {
    font-size: 45px;
}

.error-details {
    font-size: 20px;
}
</style>
